import { render, staticRenderFns } from "./ButtonRoundOutline.vue?vue&type=template&id=ec5a740e&lang=pug"
import script from "./ButtonRoundOutline.vue?vue&type=script&lang=js"
export * from "./ButtonRoundOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports